import Armont81 from '../../../BSD/Armont/Tipe 8/Tipe 8 (1).webp'
import Armont82 from '../../../BSD/Armont/Tipe 8/Tipe 8 (2).webp'
import Armont83 from '../../../BSD/Armont/Tipe 8/Tipe 8 (3).webp'
import Armont84 from '../../../BSD/Armont/Tipe 8/Tipe 8 (4).webp'



const Armont8images =[
Armont81,Armont82,Armont83,Armont84
]

export default Armont8images;